import { render } from "./IncidentTable.vue?vue&type=template&id=5556d159"
import script from "./IncidentTable.vue?vue&type=script&lang=js"
export * from "./IncidentTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__